(() => {
    const initializeRoot = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const dialog = root.querySelector('[data-osg-dialog]');
      const track = root.querySelector('[data-osg-track]');
      const viewport = root.querySelector('[data-osg-viewport]');
      const slides = Array.from(root.querySelectorAll('[data-osg-slide]'));
      const stepButtons = Array.from(root.querySelectorAll('[data-osg-go]'));
      const back = root.querySelector('[data-osg-back]');
      const next = root.querySelector('[data-osg-next]');
      const start = root.querySelector('[data-osg-start]');
      let step = 0;
      let range = 'eyewear';
      let mode = 'colours';
      let colour = 'black';
      let colourLabel = root.querySelector('[data-osg-colour-name]').textContent;
      let quantity = 3;
      let pointerStart = null;
      let pointerDelta = 0;
      let closeTimer = null;

      const total = () => mode === 'colours' && colour === 'assorted' ? 6 : quantity;
      const valid = () => total() >= 3;
      const remember = () => { try { window.localStorage.setItem(root.dataset.seenKey, 'true'); } catch (error) { return false; } return true; };
      const seen = () => { try { return window.localStorage.getItem(root.dataset.seenKey) === 'true'; } catch (error) { return false; } };
      const popoverSupported = typeof dialog.showPopover === 'function' && typeof dialog.hidePopover === 'function';
      const isOpen = () => popoverSupported ? dialog.matches(':popover-open') : dialog.classList.contains('is-open');
      const showDialog = () => {
        if (popoverSupported) dialog.showPopover();
        else {
          dialog.classList.add('is-open');
          if (window.location.hash !== `#${dialog.id}`) window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}#${dialog.id}`);
        }
      };
      const hideDialog = () => {
        if (popoverSupported) dialog.hidePopover();
        else {
          dialog.classList.remove('is-open');
          if (window.location.hash === `#${dialog.id}`) window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
        }
      };

      const renderOrder = () => {
        const assorted = mode === 'colours' && colour === 'assorted';
        root.querySelector('[data-osg-normal-quantity]').hidden = assorted;
        root.querySelector('[data-osg-assorted-quantity]').hidden = !assorted;
        root.querySelector('[data-osg-quantity]').textContent = total();
        root.querySelector('[data-osg-count]').textContent = quantity;
        root.querySelector('[data-osg-quantity-label]').textContent = mode === 'single' ? root.querySelector('[data-osg-no-colour] strong').textContent : colourLabel;
        const validation = root.querySelector('[data-osg-validation]');
        validation.classList.toggle('is-valid', valid());
        validation.querySelector('[data-osg-validation-text]').textContent = valid() ? validation.dataset.valid : validation.dataset.invalid;
        next.disabled = step === 2 && !valid();
      };

      const render = () => {
        track.classList.remove('is-dragging');
        track.style.transform = `translateX(-${step * 25}%)`;
        slides.forEach((slide, index) => {
          const active = index === step;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        stepButtons.forEach((button, index) => {
          const active = index === step;
          button.classList.toggle('is-active', active);
          if (active) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current');
        });
        back.disabled = step === 0;
        next.hidden = step === slides.length - 1;
        start.hidden = step !== slides.length - 1;
        renderOrder();
      };

      const openStep = (target) => {
        const nextStep = Math.max(0, Math.min(slides.length - 1, target));
        if (nextStep === 3 && !valid()) return;
        step = nextStep;
        render();
      };

      const close = () => {
        remember();
        if (!isOpen() || dialog.classList.contains('is-closing')) return;
        dialog.classList.add('is-closing');
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          hideDialog();
          dialog.classList.remove('is-closing');
        }, 260);
      };
      root.osgDialog = dialog;
      root.osgOpen = () => {
        window.clearTimeout(closeTimer);
        dialog.classList.remove('is-closing');
        openStep(0);
        showDialog();
      };
      root.querySelector('[data-osg-close]')?.addEventListener('click', (event) => { event.preventDefault(); close(); });
      root.querySelector('[data-osg-skip]').addEventListener('click', (event) => { event.preventDefault(); close(); });
      start.addEventListener('click', remember);
      dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
      dialog.addEventListener('close', () => dialog.classList.remove('is-closing'));
      stepButtons.forEach((button) => button.addEventListener('click', () => openStep(Number(button.dataset.osgGo))));
      back.addEventListener('click', () => openStep(step - 1));
      next.addEventListener('click', () => openStep(step + 1));
      root.querySelectorAll('[data-osg-range]').forEach((button) => button.addEventListener('click', () => {
        range = button.dataset.osgRange;
        root.querySelectorAll('[data-osg-range]').forEach((item) => {
          const active = item.dataset.osgRange === range;
          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-pressed', String(active));
        });
      }));
      viewport.addEventListener('pointerdown', (event) => {
        if (event.target.closest('button, a, input')) return;
        pointerStart = event.clientX;
        pointerDelta = 0;
        track.classList.add('is-dragging');
      });
      viewport.addEventListener('pointermove', (event) => {
        if (pointerStart === null) return;
        pointerDelta = event.clientX - pointerStart;
        if ((step === 0 && pointerDelta > 0) || (step === slides.length - 1 && pointerDelta < 0)) pointerDelta *= .28;
        track.style.transform = `translateX(calc(-${step * 25}% + ${pointerDelta}px))`;
      });
      viewport.addEventListener('pointerup', (event) => {
        if (pointerStart === null) return;
        pointerDelta = event.clientX - pointerStart;
        pointerStart = null;
        if (Math.abs(pointerDelta) >= 55) openStep(step + (pointerDelta < 0 ? 1 : -1)); else render();
        pointerDelta = 0;
      });
      viewport.addEventListener('pointercancel', () => { pointerStart = null; pointerDelta = 0; render(); });
      root.querySelectorAll('[data-osg-mode]').forEach((button) => button.addEventListener('click', () => {
        mode = button.dataset.osgMode;
        root.querySelectorAll('[data-osg-mode]').forEach((item) => { const active = item === button; item.classList.toggle('is-active', active); item.setAttribute('aria-pressed', String(active)); });
        root.querySelector('[data-osg-colour-panel]').hidden = mode === 'single';
        root.querySelector('[data-osg-no-colour]').hidden = mode !== 'single';
        if (mode === 'single') colour = 'black';
        renderOrder();
      }));
      root.querySelectorAll('[data-osg-colour]').forEach((button) => button.addEventListener('click', () => {
        colour = button.dataset.osgColour;
        colourLabel = button.dataset.label;
        root.querySelectorAll('[data-osg-colour]').forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
          const demoCount = item.querySelector('.osg__mini-counter b');
          if (demoCount) demoCount.textContent = active ? (item.dataset.osgColour === 'assorted' ? '1' : '3') : '0';
        });
        root.querySelector('[data-osg-colour-name]').textContent = colourLabel;
        renderOrder();
      }));
      root.querySelector('[data-osg-minus]').addEventListener('click', () => { quantity = Math.max(0, quantity - 1); renderOrder(); });
      root.querySelector('[data-osg-plus]').addEventListener('click', () => { quantity += 1; renderOrder(); });
      render();
      if (root.dataset.autoOpen === 'true' && root.dataset.designMode !== 'true' && !seen()) window.setTimeout(() => {
        if (seen()) return;
        remember();
        dialog.classList.remove('is-closing');
        showDialog();
      }, 700);
    };

    const refreshRoots = () => {
      document.querySelectorAll('[data-osg-root]').forEach((root) => {
        const dialog = root.querySelector('[data-osg-dialog]');
        if (root.osgDialog === dialog && typeof root.osgOpen === 'function') return;
        root.removeAttribute('data-initialized');
        initializeRoot(root);
      });
    };
    window.__osgRefresh = refreshRoots;
    refreshRoots();
    new MutationObserver(refreshRoots).observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(refreshRoots, 500);
    window.setTimeout(refreshRoots, 1500);
    document.addEventListener('click', (event) => {
      const opener = event.target.closest?.('[data-osg-open]');
      if (!opener) return;
      const root = opener.closest('[data-osg-root]');
      if (!root) return;
      const dialog = root.querySelector('[data-osg-dialog]');
      if (root.osgDialog !== dialog || typeof root.osgOpen !== 'function') {
        root.removeAttribute('data-initialized');
        initializeRoot(root);
      }
      root.osgOpen?.();
    }, true);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-osg-root]').forEach(initializeRoot);
    });
  })();
